var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.$vuetify.breakpoint.name != 'xs')?_c('Haeder'):_vm._e(),(_vm.$vuetify.breakpoint.name == 'xs')?_c('Haederxs'):_vm._e(),_c('v-main',[_c('router-view',[_vm._v(" > ")])],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }